import React, { useState } from "react";
import { ScanTimeline as Timeline, TimelineStep } from "../../services/physicalIdentityApi";

/** 16 Sep, or 16 Sep 2025 when it is not this year. */
export const scanDay = (day?: string | null) => {
  if (!day) return "";
  const d = new Date(`${day}T00:00:00`);
  if (Number.isNaN(d.getTime())) return day;
  const sameYear = d.getFullYear() === new Date().getFullYear();
  return d.toLocaleDateString("en-IN", { day: "numeric", month: "short", ...(sameYear ? {} : { year: "numeric" }) });
};

/** Steps shown before "Show all": the current one and what led to it, most of a phone screen. */
const FIRST = 8;

/** The piece's journey, latest step on top; the current stage is marked and the rest are done. */
export default function ScanTimeline({ timeline }: { timeline: Timeline }) {
  const [all, setAll] = useState(false);
  const steps = timeline.steps || [];
  if (!steps.length) return <p className="scan-empty">No steps recorded yet. They appear here as the saree is woven and sold.</p>;
  const currentAt = steps.findIndex(s => s.current);
  const shown = all ? steps : steps.slice(0, FIRST);
  return <section className="scan-timeline" aria-label="Journey, latest first">
    <ol>
      {shown.map((step, i) => <Step key={`${step.kind}-${step.date}-${i}`} step={step} state={i === currentAt ? "now" : i < currentAt ? "later" : "done"} />)}
    </ol>
    {steps.length > FIRST && <button type="button" className="scan-link-btn" onClick={() => setAll(!all)} aria-expanded={all}>
      {all ? "Show fewer steps" : `Show all ${steps.length} steps`}
    </button>}
    {timeline.more && all && <p className="scan-note">Older steps are kept in the product’s history.</p>}
  </section>;
}

function Step({ step, state }: { step: TimelineStep; state: "now" | "done" | "later" }) {
  return <li className={`scan-step is-${state}`} aria-current={state === "now" ? "step" : undefined}>
    <span className="scan-step__mark" aria-hidden="true">{state === "now" ? "" : "✓"}</span>
    <div className="scan-step__body">
      <div className="scan-step__head">
        <strong>{step.title}</strong>
        {step.date && <time dateTime={step.date}>{step.live ? `Updated ${scanDay(step.date)}` : scanDay(step.date)}</time>}
      </div>
      {step.detail && <p>{step.detail}</p>}
      {typeof step.progress === "number" && <div className="scan-progress" role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={step.progress} aria-label="Woven so far">
        <span style={{ transform: `scaleX(${Math.max(0, Math.min(100, step.progress)) / 100})` }} />
      </div>}
    </div>
  </li>;
}
